import React from 'react';
import { EhrStateProvider } from './ehr-state/EhrState.store';

export const StatesProvider = ({ children }: { children: React.ReactNode }) => {
  return <EhrStateProvider>{children}</EhrStateProvider>;
};
